import { cn } from "@/lib/utils";

const SPARKLE_PATH =
  "M12 0c.55 6.6 1.45 7.5 12 8-10.55.5-11.45 1.4-12 8-.55-6.6-1.45-7.5-12-8 10.55-.5 11.45-1.4 12-8Z";

// Deterministic (SSR-safe) twinkle positions.
const POS: { top: string; left: string; size: number; delay: string }[] = [
  { top: "12%", left: "8%", size: 16, delay: "0.2s" },
  { top: "22%", left: "82%", size: 13, delay: "1.1s" },
  { top: "68%", left: "14%", size: 18, delay: "1.8s" },
  { top: "78%", left: "72%", size: 14, delay: "0.6s" },
  { top: "44%", left: "46%", size: 11, delay: "2.4s" },
  { top: "8%", left: "55%", size: 12, delay: "3s" },
  { top: "54%", left: "90%", size: 10, delay: "1.4s" },
  { top: "86%", left: "40%", size: 12, delay: "0.9s" },
  { top: "30%", left: "28%", size: 14, delay: "2s" },
  { top: "60%", left: "62%", size: 15, delay: "1.6s" },
  { top: "16%", left: "70%", size: 11, delay: "2.8s" },
  { top: "74%", left: "24%", size: 13, delay: "0.5s" },
];

export function Sparkles({
  count = 6,
  className,
  color = "gold",
}: {
  count?: number;
  className?: string;
  color?: "gold" | "white" | "pink";
}) {
  const items = POS.slice(0, count);
  return (
    <div
      className={cn("pointer-events-none absolute inset-0 overflow-hidden", className)}
      aria-hidden
    >
      {items.map((p, i) => (
        <svg
          key={i}
          viewBox="0 0 24 24"
          className={cn("twinkle-star", color === "white" && "white", color === "pink" && "pink")}
          style={{
            top: p.top,
            left: p.left,
            width: p.size,
            height: p.size,
            animationDelay: p.delay,
          }}
        >
          <path d={SPARKLE_PATH} fill="currentColor" />
        </svg>
      ))}
    </div>
  );
}

/** Single standalone sparkle (for headings/badges). */
export function Sparkle({
  className,
  color = "gold",
}: {
  className?: string;
  color?: "gold" | "white";
}) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={cn("twinkle-star", color === "white" && "white", className)}
      aria-hidden
    >
      <path d={SPARKLE_PATH} fill="currentColor" />
    </svg>
  );
}
